import React, { useState, useEffect } from "react";
import Login from "./components/auth-component/Login";
import ForgotPassword from "./components/auth-component/ForgetPassword";
import Offline from "./components/auth-component/OfflinePage";
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,

} from "react-router-dom";
import { NavigationRoutes } from './constant/Routes';
import GlobalStyle from './constant/GlobalStyle';
import { applyTheme } from './constant/ApplyTheme';
import AdminDashboard from "./components/admin-component/AdminDashboard";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import PrivatRoutes from "./helpers/AdminAuthentication";
import CreateNewPassword from "./components/auth-component/CreateNewPassword";
import localStorageServices from "./services/LocalStorage";
import { LocalStorageKeys } from "./constant/LocalStorageKeys";
import {jwtDecode} from "jwt-decode";


function App() {
  const [is_online, setIs_online] = useState(true)  //online status
  window.addEventListener("online", function () {
    // console.log("internet is ok!👍")
    setIs_online(true)
  });

  window.addEventListener("offline", function () {              //to check the internet connection

    setIs_online(false)

  });
  //Colors setting 


  applyTheme();
  /// is user details is not exit redirect to login 
  useEffect(() => {
    const checkTokenExpiration = () => {
      let token = localStorageServices.getItem(LocalStorageKeys.userToken);

      if (token) {
        try {
          let decoded = jwtDecode(token.token); // Assuming token is a string
          console.log(`Token value is ${JSON.stringify(decoded)}`)
          let exp = decoded?.exp;
          let currentTime = Math.floor(Date.now() / 1000); // Convert ms to seconds

          if (currentTime >= exp) {
            console.warn("Token expired, redirecting to logout...");
            localStorage.clear();
            window.location.href =NavigationRoutes.LOGIN;
          }
        } catch (error) {
          console.error("Invalid token:", error);
          localStorage.clear();
          window.location.href = NavigationRoutes.LOGIN;
        }
      }
    };

    checkTokenExpiration();
  }, []);
  return (<>
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <Provider store={store}>
      <GlobalStyle />
      <Router>
        {
          is_online ?
            <Routes>
              {/* Redirect /admin to /admin/login */}
              <Route path="/" element={<Navigate to={NavigationRoutes.LOGIN} />} />
              {/* Redirect /admin to /admin/login */}

              <Route exact path={NavigationRoutes.LOGIN} element={<Login />} />
              <Route exact path={NavigationRoutes.FORGOT_PASSWORD} element={<ForgotPassword />} />
              <Route element={<PrivatRoutes />}>

                <Route path={`${NavigationRoutes.ADMIN_DASHBOARD}/*`} element={<AdminDashboard />} />
              </Route>
                <Route path={NavigationRoutes.CREATE_NEW_PASSWORD} element={<CreateNewPassword />} />
            </Routes>
            : <Routes>
              <Route exact path="*" element={<Offline isFullPage={true} />} />
              {/*  passed a prop isFullPage to correct css for full page or to render in a component  */}
            </Routes>
        }
      </Router>
    </Provider>
  </>
  );
}

export default App;
